import { render, staticRenderFns } from "./onboardingVP1.vue?vue&type=template&id=6a38232c&scoped=true"
import script from "./onboardingVP1.vue?vue&type=script&lang=js"
export * from "./onboardingVP1.vue?vue&type=script&lang=js"
import style0 from "./onboardingVP1.vue?vue&type=style&index=0&id=6a38232c&prod&lang=scss&scoped=true"
import style1 from "./onboardingVP1.vue?vue&type=style&index=1&id=6a38232c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38232c",
  null
  
)

export default component.exports